import { render } from "./YellowPlacemat.svg?vue&type=template&id=21737b48"
const script = {}
script.render = render

export default script